import React from 'react'
import './general_liability.scss'
import {
    Hero, MainHeading,
    Breadcrumb, CommonTabs,
    SentryCard, Plans,
    NewsCard, Faq, SuccessStories,
    BussinessForm, FindAgent, OneBlueCard
} from '../../../components';
import { images } from "../../../utils/customFn";
import { Container } from 'react-bootstrap';
const GeneralLiability = () => {
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "what-we-offer/insurance-products" },
        { label: "General liability insurance", link: "what-we-offer/insurance-products/general-liability-insurance" },
    ];


    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "#/",
            label: "The Sentry difference",
        },
        {
            id: "coverages",
            href: "#/",
            label: "General liability coverages",
        },
        {
            id: "help",
            href: "#/",
            label: "Who we've helped",
        },
    ];
    const bluecarddata = {
        heading1: 'What is general liability insurance?',
        para1: 'General liability insurance coverage is the foundation of your business’s liability protection. Our general liability insurance helps protect your large or small business from losses caused by your services, operations, or employees. This type of protection helps cover medical expenses, legal expenses, and damages included in your policy.',
        para2: 'As a business owner, general liability insurance helps protect your bottom line, so you can focus on running your company.',
        blue_card_heading: 'Learn more about our general liability coverage.',
        blue_card_para: 'We’ll work with you to build a general liability coverage plan that makes sense for you and your employees.',
        button_text: "Let's talk"
    }
    const sectrydata = {
        banner: images['two_people_smiling_and_looking_at_laptop.avif'],
        heading: 'The Sentry difference',
        subheading: 'Liability insurance for your business',
        para: 'We’ll work with you to determine what liability insurance coverage is appropriate for your organization. Our goal is to help make sure you’re protected from the actual exposures and risks your business faces.',
        sideheading: 'We’ve been protecting businesses since 1904',
        sidepara: 'We draw on our insurance experience and leverage our industry knowledge to help you protect your business and your future.',
        sideImg: images['two-blue-shields-card.svg']
    }
    const plansData = {
        blue_heading: 'Risk management services that work',
        blue_para: 'We want to help you avoid the pitfalls that can lead to a claim. And we’ve had success doing this by working with large and small business owners and commercial organizations to identify and reduce risks. Our safety services staff will be your allies.',
        purple_icon: images['Icon_of_two_purple_birds.svg'],
        purple_heading: 'Accurate and fair claims resolutions',
        purple_para: "When you file a claim, you’ll be assigned a claims specialist who’s knowledgeable about your industry and your policy type. This experience and claims expertise helps us reach claims resolutions that are fair and equitable.",
    }
    const NewsCardData = [
        {
            id: 1,
            title: 'Business liability insurance',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'More about business liability insurance >',
        },
        {
            id: 2,
            title: 'Commercial umbrella insurance',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'More about commercial umbrella insurance >',
        },
        {
            id: 3,
            title: 'Errors and omissions coverage',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about E&O insurance >',
        },

    ];
    const faqData = [
        {
            id: 1,
            eventKey: 1,
            header: 'How much does a general liability insurance policy cost? How do I know how much coverage my company needs?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        },
        {
            id: 2,
            eventKey: 2,
            header: 'If we already have business liability insurance, why would I need commercial umbrella coverage?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        },
        {
            id: 3,
            eventKey: 3,
            header: 'We’re concerned about hackers breaking in to our company database. How can you help?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        }
    ]
    return (
        <>
            <div className='general_liability'>
                {/* hero section */}
                <Hero img={images["hero-general-liability-two-people-in-hard-hats-surveying-large.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />

                    {/* heading  */}
                    <MainHeading title="General liability insurance" showshare={false} />

                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} />

                    {/* Layout */}
                    <OneBlueCard data={bluecarddata} />

                    {/* the sentry card */}
                    <SentryCard data={sectrydata} />

                    {/* Plans section */}
                    <Plans data={plansData} />

                    {/* news card section */}
                    <NewsCard Title="Our general liability coverages include:" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />

                    {/* FAQ section */}
                    <Faq heading="General liability FAQs" FaqData={faqData} />

                    {/* success stories */}
                    <SuccessStories showSeemore={true} />

                    {/* news  */}
                    <NewsCard Title="News and resources" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />

                    <BussinessForm />
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default GeneralLiability